module.exports = __webpack_public_path__ + "static/quartz-crystal-snake-chain-bracelet-505034c0373b36f0595708ba6d8cdf6b.jpg";